import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { StoragePanelComponent } from "./storage-panel/storage-panel.component";
import { CalendarModule } from "primeng/calendar";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { DialogModule } from "primeng/dialog";
import { StoragePanelRoutingModule } from "./storage-panel-routing.module";
import { TextareaModule } from 'primeng/textarea';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
    imports:[
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        StoragePanelRoutingModule,
        CalendarModule,
        ButtonModule,
        InputTextModule,
        DialogModule,
        TextareaModule,
        TableModule,
        CardModule,
        DropdownModule,
    ],
    declarations:[
        StoragePanelComponent,
    ],
})
export class StoragePanelModule{}